<template>
    <router-link to="/voucher" tag="li"><a><i class="fa fa-ticket"></i><span>Kode Voucher</span></a></router-link>
</template>
<script>
export default {
    name: 'voucher-nav'
}
</script>


// WEBPACK FOOTER //
// Navigation.vue?6f96a08e